import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import { auth, db } from "../../Security/firebase-config";
import "../General-Page.css";
// import "./Haven-KJ.css";
import "../../utils/ImageHoverEffect.css";
import { applyImageZoomEffect } from '../../utils/ImageHoverEffect';
import Footer from "../../components/core-components/Footer";
import GuideImage from "../../components/core-components/GuideImage";
import Highlight from "../../components/core-components/Highlight";
import Favorites from "../../components/core-components/Favorites";
import { useBlur } from "../../context/BlurContext";
import LazyVideo from "../../components/core-components/LazyVideo";
import GuideMediaPlaceholder from "../../components/core-components/GuideMediaPlaceholder";
import MovementGuideModal from "../../components/core-components/MovementGuideModal";
import useAccordionDoubleClick from "../../hooks/useAccordionDoubleClick";
import {
  getGuideMediaPreloadSrc,
  isPlannedGuideMedia,
  plannedGuideImage,
} from "../../utils/guideMediaPlanning";




const mediaSources = {
  /* =========================
   * DEFENSE
   * ========================= */

  // ----- Standard Setups (in UI order) -----
  "A-Site-Anchor-Setup": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-A-Anchor-Setup-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  "B-Site-and-Garage-Setup": {
    // (no media defined yet)
  },

  // Shown in UI as "Default Setup"
  "C-Site-and-Garage-Setup": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Default-Setup.mp4",
      props: { ui: "minimal", loop: true }
    },
    "c-main-nano-from-c-link": {
      label: "Nanoswarm Lineup",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-DEF-C-Main-Nano-From-C-Link-fast.mp4"
    },
    "Reaction Vs Heavy A": {
      label: "Reaction Vs Heavy A",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Default-Setup-IF-Heavy-A.mp4",
      props: { ui: "minimal", loop: true }
    },
    "Reaction Vs C-Long Hit": {
      label: "Reaction Vs C-Long Hit",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Default-Setup-IF-C-Hit.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  // NEW section (placed after "Default Setup" in UI)
  "Default-Setup-Variation-1-(Passive Garage)": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Garage-Anchor-Setup-fast.mp4",
      props: { ui: "minimal", loop: true }
    },
    "reaction-vs-5-c-long": {
      label: "Reaction Vs 5 C-Long",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Garage-Anchor-Setup-IF-5-C-Long-fast.mp4",
      props: { ui: "minimal", loop: true }
    },
    "reaction-vs-c-split": {
      label: "Reaction Vs C-Split",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Garage-Anchor-Setup-IF-Garage-Split-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  "C-Site-Anchor-Setup": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-C-Anchor-Setup-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  // ----- Retake Setups -----
  "How-to-Play-A-Retake-with-Ult": {
    "overview-image-a": {
      label: "Overview",
      type: "image",
      src: "/assets/Ind-Haven/KJ/Haven-DEF-KJ-A-retake-with-Ult.png"
    },
    "retake-a-video": {
      label: "Nanoswarm lineup",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-A-Retake-With-Ult-fast.mp4"
    }
  },

  "How-to-Play-B-Retake-with-Ult": {
    "overview-image-b": {
      label: "Overview",
      type: "image",
      src: "/assets/Ind-Haven/KJ/Haven-DEF-KJ-B-retake-with-Ult.png"
    }
  },

  "How-to-Play-C-Retake-with-Ult": {
    "overview-image-c": {
      label: "Overview",
      type: "image",
      src: "/assets/Ind-Haven/KJ/Haven-DEF-KJ-C-retake-with-Ult.png"
    },
    "retake-c-video": {
      label: "Nanoswarm lineup",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-C-Retake-With-Ult-fast.mp4"
    }
  },

  // ----- Defensive Set-Plays (only items with media shown) -----
  "A-Long-Trap-Play": {
    "trap-play-a-long-with-omen": {
      label: "Trap Play A-Long with Omen",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Haven-KJ-DEF-Trap-Play-A-Long-W-Omen-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  /* =========================
   * ATTACK
   * ========================= */

  // ----- How to Default As KJ -----
  "How-to-Default-As-KJ": {
    "overview-image": plannedGuideImage("Ind-Haven/KJ/Haven-KJ-HTD.png")
  },

  "A-Hit-with-4-or-A-Heavy-Default": {
    "overview-image": plannedGuideImage("Ind-Haven/KJ/Haven-KJ-HTD.png"),
    "b-main-molly-from-a-lobby": {
      label: "B-Main Molly From A-Lobby",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-B-Main-Molly-From-A-Lobby-fast.mp4"
    },
    "c-spawn-nano": {
      label: "B-Nano From C T-Spawn",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Default-C-Spawn-B-Nano-fast.mp4"
    }
  },

  "Team-Heavy-B-or-Garage-Default": {
    // (no media defined yet)
  },

  "C-or-Garage-Heavy-Default": {
    "a-lobby-nano": {
      label: "B-Nano From A-Lobby",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-haven-KJ-ATK-HTD-B-Main-Molly-From-A-Lobby-fast.mp4"
    }
  },

  // ----- Site-Hit Positioning & Pathing → A-Hit -----
  "Committed-A-Hit-From-Long": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Haven-KJ-ATK-A-site-from-long-fast.mp4",
      props: { ui: "minimal", loop: true }
    },
    "a-long-backsite-nano": {
      label: "A-Long-Backsite-Nano",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Backsite-Nano-From-A-Long-fast.mp4"
    },
    "a-long-ct-nano": {
      label: "A-Long-CT-Nano",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-CT-Nano-From-A-Long-fast.mp4"
    }
  },

  // UPDATED: replace overview image with video requested
  "Committed-A-Hit-From-Short": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Rush-From-Short-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  "A-Hit-Support-With-Mid-Rewrap": {
    "overview-image": plannedGuideImage("Ind-Haven/KJ/Haven-KJ-ATK-A-Mid-Rewrap.png"),
    "a-backsite-nano-from-a-lobby": {
      label: "A-Backsite-Nano (from A-Lobby)",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Backsite-Nano-From-A-Lobby-fast.mp4"
    },
    "a-ct-nano-from-a-lobby": {
      label: "A-CT-Nano (from A-Lobby)",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-CT-Nano-From-A-Lobby-fast.mp4"
    },
    "b-main-molly-from-a-lobby": {
      label: "B-Main Molly From A-Lobby",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-B-Main-Molly-From-A-Lobby-fast.mp4"
    }
  },

  // ----- Site-Hit Positioning & Pathing → B-Hit -----
  "B-Hit": {
    "overview-image": plannedGuideImage("Ind-Haven/KJ/Haven-KJ-ATK-B-Hit-Overview.png")
  },

  // ----- Site-Hit Positioning & Pathing → C-Hit -----
  // UPDATED: replace overview image with the new overview video
  "C-Long-Hit": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Rush-5-fast.mp4",
      props: { ui: "minimal", loop: true }
    },
    "c-close-garage-molly-from-c-lobby": {
      label: "Close Garage Molly (from C-Lobby)",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-Close-Garage-Molly-From-C-Lobby-fast.mp4",
    },
    "c-ct-nano-from-c-lobby": {
      label: "C CT Nano (from C Lobby)",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-C-CT-Nano-From-C-Lobby-fast.mp4",
    },
    "c-backplat-nano": {
      label: "C BackPlat Nano",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-BackPlat-Nano-fast.mp4",
    }
  },

  // UPDATED: replace overview with the new split overview video
  "C-Split": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Split-fast.mp4",
      props: { ui: "minimal", loop: true }
    },
    "ct-molly-from-grass": {
      label: "CT Molly from Grass",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Molly-From-Grass-fast.mp4",
    }
  },

  // ----- Plans Around Ultimate -----
  "A-Site-Ult": {
    "overview-video": {
      label: "Overview",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Ult-fast.mp4",
      props: { ui: "minimal", loop: true }
    }
  },

  "B-Site-Ult": {
    // (no media defined yet)
  },

  "C-Site-Ult": {
    // (no media defined yet)
  },

  // ----- Post-Plants -----
  "A-PP-Nano": {
    "overview-image-a-pp": {
      label: "Overview",
      type: "image",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP-Nano.png"
    },
    "molly-from-a-link": {
      label: "Nanoswarm lineup from A-Link",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-A-PP-Nano-From-A-Link-fast.mp4"
    },
    "molly-from-far-a-long": {
      label: "Nanoswarm lineup from Far A-Long",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP-Molly-From-Far-A-Long-fast.mp4"
    }
  },

  // UPDATED: overview image replaced with the requested PNG
  "C-PP-Nano": {
    "overview-image-c-pp": {
      label: "Overview",
      type: "image",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-PP-Nano.png",
    },
    "molly-from-c-link": {
      label: "Nanoswarm lineup from C-Link",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-PP-Nano-From-C-Link-fast.mp4",
    },
    "molly-from-c-long": {
      label: "Nanoswarm lineup from C-Long",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-C-PP-Nano-From-C-Long-fast.mp4",
    }
  },

  // ----- Specific Agent Counters (Attack) -----
  "KJ-A-Retake-Ult-Counter": {
    "overview-image": plannedGuideImage(
      "Ind-Haven/KJ/Haven-KJ-ATK-Counter-A-Retake-Ult.png"
    ),
    "counter-a-def-ult-nano-from-a-long": {
      label: "Counter Ult Nano (from A-Long)",
      type: "video",
      src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-Counter-A-DEF-Ult-Nano-From-A-Long-fast.mp4"
    }
  }
};

  
  // "A-Hit-Committed": {
  //   "filler-video": {
  //     label: "Filler",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Filler.mp4",
  //   },
  //   "a-long-backsite-nano": {
  //     label: "A-Long-Backsite-Nano",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Backsite-Nano-From-A-Long-fast.mp4",
  //   },
  //   "a-long-ct-nano": {
  //     label: "A-Long-CT-Nano",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-CT-Nano-From-A-Long-fast.mp4",
  //   },
  // },
  
  // "A-Hit-from-Long": {
  //   "overview-video": {
  //     label: "Overview",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Haven-KJ-ATK-A-site-from-long-fast.mp4",
  //     props: {
  //       className: "slow-video",
  //       playbackRate: 0.7,
  //       loop: true,
  //     },
  //   },
  //   "ct-nanoswarm": {
  //     label: "CT-Nanoswarm",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Haven-KJ-ATK-A-CT-Molly-fast.mp4",
  //   },
  //   "back-site-nanoswarm": {
  //     label: "Back-Site-Nanoswarm",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Back-Site-Molly-fast.mp4",
  //   },
  //   "god-smoke-nanoswarm": {
  //     label: "God-Smoke-Nanoswarm",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-God-Smoke-Molly-fast.mp4",
  //   },
  // },
  // "C-Long-Hit-Committed": {
  //   "filler-video": {
  //     label: "Overview (Filler)",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Filler.mp4",
  //   },
  //   "back-plat-molly": {
  //     label: "Back Plat Molly",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Back-Plat-Molly-fast.mp4",
  //   },
  //   "ct-molly": {
  //     label: "CT Molly",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Molly-fast.mp4",
  //   },
  //   "garage-molly": {
  //     label: "Garage Molly",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Garage-Molly-fast.mp4",
  //   },
  //   "ct-garage-rollout": {
  //     label: "CT & Garage Molly Rollout",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT&Garage-Molly-Rollout-fast.mp4",
  //   },
  // },
  // "C-Split": {
  //   "overview-video": {
  //     label: "Overview from Grass",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Overview-From-Grass-fast.mp4",
  //   },
  //   "ct-nano-from-grass": {
  //     label: "CT Molly from Grass",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Molly-From-Grass-fast.mp4",
  //   },
  // },
  // "A-PP-Nano": {
  //   "overview-image-a-pp": {
  //     label: "Overview",
  //     type: "image",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP.png",
  //   },
  //   "molly-from-a-link": {
  //     label: "Nanoswarm lineup from A-Link",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-Kj-ATK-A-PP-Nano-From-A-Link-fast.mp4",
  //   },
  //   "molly-from-far-a-long": {
  //     label: "Nanoswarm lineup from Far A-Long",
  //     type: "video",
  //     src: "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP-Molly-From-Far-A-Long-fast.mp4",
  //   },
  // },



const HavenKJ= () => {
  const [userTeamId, setUserTeamId] = useState(null);
  const imageContainerRef = useRef(null);
  const { isBlurred } = useBlur(); // Access blur state
  const [selectedImage, setSelectedImage] = useState("image1");
  const [selectedMediaBySection, setSelectedMediaBySection] = useState({});
  const [openAccordions, setOpenAccordions] = useState({});
  useAccordionDoubleClick({ openAccordions, setOpenAccordions });
  const location = useLocation();
  const [isMovementGuideOpen, setIsMovementGuideOpen] = useState(false);
  const [zoomEnabledBySection, setZoomEnabledBySection] = useState({});

  

  // ✅ Auto-expand accordions & scroll to highlight
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const highlightId = params.get("highlight");

    if (highlightId) {
      const accordionMap = {
        // ===== Top level mains =====
        "Indiv-Haven-KJ-Defense-Main": ["Defense-Main"],
        "Indiv-Haven-KJ-Attack-Main": ["Attack-Main"],
        "Indiv-Haven-KJ-Common-Agent-Combos": ["Common-Agent-Combos"],

        // ===== Defense =====
        "Indiv-Haven-KJ-Standard-Setups": ["Defense-Main", "Standard-Setups"],

        "Indiv-Haven-KJ-A-Site-Anchor-Setup": [
          "Defense-Main",
          "Standard-Setups",
          "A-Site-Anchor-Setup",
        ],
        "Indiv-Haven-KJ-B-Site-and-Garage-Setup": [
          "Defense-Main",
          "Standard-Setups",
          "B-Site-and-Garage-Setup",
        ],
        // UI label = "Default Setup" (media key = C-Site-and-Garage-Setup)
        "Indiv-Haven-KJ-C-Site-and-Garage-Setup": [
          "Defense-Main",
          "Standard-Setups",
          "C-Site-and-Garage-Setup",
        ],
        // NEW: Default Setup Variation 1 (Passive Garage)
        "Indiv-Haven-KJ-Default-Setup-Variation-1-(Passive Garage)": [
          "Defense-Main",
          "Standard-Setups",
          "Default-Setup-Variation-1-(Passive Garage)",
        ],
        "Indiv-Haven-KJ-C-Site-Anchor-Setup": [
          "Defense-Main",
          "Standard-Setups",
          "C-Site-Anchor-Setup",
        ],

        // Retake Setups (container + 3 leaves that your JSX renders as ARetake/BRetake/CRetake)
        "Indiv-Haven-KJ-Retake-Setups": ["Defense-Main", "Retake-Setups"],
        "Indiv-Haven-KJ-ARetake": ["Defense-Main", "Retake-Setups", "ARetake"],
        "Indiv-Haven-KJ-BRetake": ["Defense-Main", "Retake-Setups", "BRetake"],
        "Indiv-Haven-KJ-CRetake": ["Defense-Main", "Retake-Setups", "CRetake"],

        // Defensive Set-Plays (containers)
        "Indiv-Haven-KJ-Defensive-Set-Plays": [
          "Defense-Main",
          "Defensive-Set-Plays",
        ],

        // Eco Strats
        "Indiv-Haven-KJ-Eco-Strats": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Eco-Strats",
        ],
        "Indiv-Haven-KJ-A-short-Shorty-trap": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Eco-Strats",
          "A-short-Shorty-trap",
        ],
        "Indiv-Haven-KJ-Walk-down-Mid": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Eco-Strats",
          "Walk-down-Mid",
        ],
        "Indiv-Haven-KJ-Garage-short-range": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Eco-Strats",
          "Garage-short-range",
        ],
        "Indiv-Haven-KJ-Walk-down-C-long": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Eco-Strats",
          "Walk-down-C-long",
        ],

        // Trap Plays
        "Indiv-Haven-KJ-Trap-Plays": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Trap-Plays",
        ],
        "Indiv-Haven-KJ-A-Short-Trap-Play": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Trap-Plays",
          "A-Short-Trap-Play",
        ],
        "Indiv-Haven-KJ-A-Long-Trap-Play": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Trap-Plays",
          "A-Long-Trap-Play",
        ],
        "Indiv-Haven-KJ-Garage-Trap-Play": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Trap-Plays",
          "Garage-Trap-Play",
        ],

        // Setups around Ultimate (Defense)
        "Indiv-Haven-KJ-Plans-Ultimates": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Plans-Ultimates",
        ],
        "Indiv-Haven-KJ-How-to-Play-A-Retake-with-Ult": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Plans-Ultimates",
          "How-to-Play-A-Retake-with-Ult",
        ],
        "Indiv-Haven-KJ-How-to-Play-B-Retake-with-Ult": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Plans-Ultimates",
          "How-to-Play-B-Retake-with-Ult",
        ],
        "Indiv-Haven-KJ-How-to-Play-C-Retake-with-Ult": [
          "Defense-Main",
          "Defensive-Set-Plays",
          "Plans-Ultimates",
          "How-to-Play-C-Retake-with-Ult",
        ],

        // Defense → Specific Agent Counters (container)
        "Indiv-Haven-KJ-Defense-Specific-Agent-Counters": [
          "Defense-Main",
          "Defense-Specific-Agent-Counters",
        ],

        // ===== Attack =====
        "Indiv-Haven-KJ-Site-Hit-Positioning-and-Pathing": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
        ],

        // A-Hit (parent + children)
        "Indiv-Haven-KJ-A-Hit": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "A-Hit",
        ],
        "Indiv-Haven-KJ-Committed-A-Hit-From-Long": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "A-Hit",
          "Committed-A-Hit-From-Long",
        ],
        "Indiv-Haven-KJ-Committed-A-Hit-From-Short": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "A-Hit",
          "Committed-A-Hit-From-Short",
        ],
        "Indiv-Haven-KJ-A-Hit-Support-With-Mid-Rewrap": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "A-Hit",
          "A-Hit-Support-With-Mid-Rewrap",
        ],

        // B-Hit (flat)
        "Indiv-Haven-KJ-B-Hit": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "B-Hit",
        ],

        // C-Hit (parent + children)
        "Indiv-Haven-KJ-C-Hit": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "C-Hit",
        ],
        "Indiv-Haven-KJ-C-Long-Hit": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "C-Hit",
          "C-Long-Hit",
        ],
        "Indiv-Haven-KJ-C-Split": [
          "Attack-Main",
          "Site-Hit-Positioning-and-Pathing",
          "C-Hit",
          "C-Split",
        ],

        // Plans Around Ultimate (Attack)
        "Indiv-Haven-KJ-Plans-Around-Ultimate": [
          "Attack-Main",
          "Plans-Around-Ultimate",
        ],
        "Indiv-Haven-KJ-A-Site-Ult": [
          "Attack-Main",
          "Plans-Around-Ultimate",
          "A-Site-Ult",
        ],
        "Indiv-Haven-KJ-B-Site-Ult": [
          "Attack-Main",
          "Plans-Around-Ultimate",
          "B-Site-Ult",
        ],
        "Indiv-Haven-KJ-C-Site-Ult": [
          "Attack-Main",
          "Plans-Around-Ultimate",
          "C-Site-Ult",
        ],

        // How to Default as KJ
        "Indiv-Haven-KJ-How-to-Default-As-KJ": [
          "Attack-Main",
          "How-to-Default-As-KJ",
        ],
        "Indiv-Haven-KJ-A-Hit-with-4-or-A-Heavy-Default": [
          "Attack-Main",
          "How-to-Default-As-KJ",
          "A-Hit-with-4-or-A-Heavy-Default",
        ],
        "Indiv-Haven-KJ-Team-Heavy-B-or-Garage-Default": [
          "Attack-Main",
          "How-to-Default-As-KJ",
          "Team-Heavy-B-or-Garage-Default",
        ],
        "Indiv-Haven-KJ-C-or-Garage-Heavy-Default": [
          "Attack-Main",
          "How-to-Default-As-KJ",
          "C-or-Garage-Heavy-Default",
        ],

        // Post-Plants
        "Indiv-Haven-KJ-Post-Plants": ["Attack-Main", "Post-Plants"],
        "Indiv-Haven-KJ-A-PP-Nano": ["Attack-Main", "Post-Plants", "A-PP-Nano"],
        "Indiv-Haven-KJ-B-PP-Nano": ["Attack-Main", "Post-Plants", "B-PP-Nano"],
        "Indiv-Haven-KJ-C-PP-Nano": ["Attack-Main", "Post-Plants", "C-PP-Nano"],

        // Specific Agent Counters (Attack)
        "Indiv-Haven-KJ-Attack-Specific-Agent-Counters": [
          "Attack-Main",
          "Attack-Specific-Agent-Counters",
        ],
        "Indiv-Haven-KJ-KJ-A-Retake-Ult-Counter": [
          "Attack-Main",
          "Attack-Specific-Agent-Counters",
          "KJ-A-Retake-Ult-Counter",
        ],
      };
      
      

      const pathsToOpen = accordionMap[highlightId];

      if (pathsToOpen) {
        setOpenAccordions((prev) => {
          const updated = { ...prev };
          pathsToOpen.forEach((key) => {
            updated[key] = true;
          });
          sessionStorage.setItem("havenKJAccordionState", JSON.stringify(updated));
          return updated;
        });

        // Give time for accordion to render
        setTimeout(() => {
          const el = document.querySelector(`[data-container-id="${highlightId}"]`);
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 500);
      }
    }
  }, [location.search]);

  useEffect(() => {
    const imageContainers = document.querySelectorAll(".image-hover-effect");
  
    if (imageContainers.length > 0) {
      const cleanupFunctions = [];
  
      imageContainers.forEach((container) => {
        const cleanup = applyImageZoomEffect(container);
        cleanupFunctions.push(cleanup);
      });
  
      return () => {
        cleanupFunctions.forEach((cleanup) => cleanup());
      };
    }
  }, []);
  

   // ✅ Hydrate all sessionStorage state on mount
   useEffect(() => {
    const storedAccordionState = sessionStorage.getItem("havenKJAccordionState");
    if (storedAccordionState) {
      try {
        const parsed = JSON.parse(storedAccordionState);
        setOpenAccordions(parsed);
  
        // ✅ Also hydrate default media if not already selected
        const newMediaState = {};
          Object.entries(parsed).forEach(([accordionId, isOpen]) => {
            if (isOpen && mediaSources[accordionId]) {
              const firstKey = Object.keys(mediaSources[accordionId])[0];
              if (firstKey) {
                newMediaState[accordionId] = firstKey;
              }
            }
          });
          if (Object.keys(newMediaState).length > 0) {
            setSelectedMediaBySection((prev) => ({
              ...prev,
              ...newMediaState
            }));
          }

        
      } catch (e) {
        console.error("Failed to parse accordion state", e);
      }
    }
  }, []);

  // ⬇️ NEW: hydrate zoom state from sessionStorage
  useEffect(() => {
    const stored = sessionStorage.getItem("havenKJZoomState");
    if (stored) {
      try {
        setZoomEnabledBySection(JSON.parse(stored));
      } catch {}
    }
  }, []);

  

  // ✅ Persist selectedMediaBySection
  useEffect(() => {
    sessionStorage.setItem("havenKJMediaState", JSON.stringify(selectedMediaBySection));
  }, [selectedMediaBySection]);

  // ✅ Persist selectedImage
  useEffect(() => {
    sessionStorage.setItem("havenKJSelectedImage", selectedImage);
  }, [selectedImage]);
    
  // ⬇️ NEW: persist zoom state per section
  useEffect(() => {
    sessionStorage.setItem("havenKJZoomState", JSON.stringify(zoomEnabledBySection));
  }, [zoomEnabledBySection]);

  useEffect(() => {
    if (imageContainerRef.current) {  // ✅ Ensure the element exists
      const cleanup = applyImageZoomEffect(imageContainerRef.current); 
  
      return () => {
        cleanup();
      };
    }
  }, []);  

  useEffect(() => {
    console.log("userTeamId in HavenMapApproach:", userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    const fetchUserTeamId = async (uid) => {
      try {
        const userDocRef = doc(db, "users", uid);
        console.log("Fetching user document:", userDocRef.path); // Log the Firestore path
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("Fetched user document data:", data); // Log the document data

          if (data.teamId) {
            console.log("Setting teamId:", data.teamId);
            setUserTeamId(data.teamId);
          } else {
            console.warn("No teamId found in user document. Setting teamId to null.");
            setUserTeamId(null);
          }
        } else {
          console.error("User document does not exist in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching user team ID:", error);
      }
    };

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated:", user.uid);
        fetchUserTeamId(user.uid); // Pass the UID to fetch the teamId
      } else {
        console.warn("No authenticated user found.");
        setUserTeamId(null); // Clear the teamId if the user logs out
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //   const prioritizedVideos = [
  //     // Most critical, preload immediately
  //     "/assets/Ind-Haven/KJ/Haven-KJ-ATK-A-site-from-long.MP4",
  //     "/assets/Ind-Haven/KJ/Filler.mp4",
  //     "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Overview-From-Grass.mp4",
  //   ];
  
  //   const secondaryVideos = [
  //     // Retake
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-A-Retake-With-Ult.mp4",
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-C-Retake-With-Ult.mp4",
        
  //     // Trap Plays
  //       "/assets/Ind-Haven/KJ/Haven-KJ-DEF-Trap-Play-A-Long-W-O-men.mp4",
        

  //     //Attack

  //        // A-ATK
  //        "/assets/Ind-Haven/KJ/Haven-KJ-ATK-A-CT-Molly.mp4",
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-Back-Site-Molly.mp4",
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-God-Smoke-Molly.mp4",
 
  //        // C Site hit from long videos
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Back-Plat-Molly.mp4",
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Molly.mp4",
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-Garage-Molly.mp4",
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT&Garage-Molly-Rollout.mp4",
         
  //        // C Site Split
  //        "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-CT-Molly-From-Grass.mp4",

  //       // HTD videos
  //       "/assets/Ind-Haven/KJ/Ind-haven-KJ-ATK-HTD-B-Main-Molly-From-C-Spawn.mp4",
  //       "/assets/Ind-Haven/KJ/Ind-haven-KJ-ATK-HTD-B-Main-Molly-From-A-Lobby.mp4",
        
  //       // A-Post-Plant videos
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP-Molly-From-A-Link.mp4",
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-A-PP-Molly-From-Far-A-Long.mp4",
    
  //       // C-Post-Plant videos
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-PP-From-C-Link.mp4",
  //       "/assets/Ind-Haven/KJ/Ind-Haven-KJ-ATK-C-PP-From-C-Long.mp4",
  //   ];
  
  //   const preloadVideo = (src, delay = 0) => {
  //     setTimeout(() => {
  //       const video = document.createElement("video");
  //       video.src = src;
  //       video.preload = "metadata"; // Lighter than full auto
  //       video.load();
  //     }, delay);
  //   };
  
  //   // Load priority videos instantly
  //   prioritizedVideos.forEach((src) => preloadVideo(src));
  
  //   // Load non-critical when idle, or fallback to staggered timeouts
  //   secondaryVideos.forEach((src) => {
  //     if ("requestIdleCallback" in window) {
  //       requestIdleCallback(() => preloadVideo(src), { timeout: 3000 });
  //     } else {
  //       setTimeout(() => preloadVideo(src), 2000);
  //     }
  //   });
  
  //   // secondaryVideos.forEach((src, index) => {
  //   //   const delay = 500 * (index + 1); // More spread out
  //   //   if ('requestIdleCallback' in window) {
  //   //     requestIdleCallback(() => preloadVideo(src), { timeout: 3000 });
  //   //   } else {
  //   //     setTimeout(() => preloadVideo(src), delay);
  //   //   }
  //   // });
    

  //   return () => {
  //     // No need to explicitly unload
  //   };
  // }, []);
  

  

  // Page transition effect
  useEffect(() => {
    document.body.classList.add("no-transition");
    const pageContainer = document.querySelector(".page__container");
    pageContainer && pageContainer.classList.add("no-transition");

    const handleLoad = () => {
      document.body.classList.remove("no-transition");
      pageContainer && pageContainer.classList.remove("no-transition");
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

   // ✅ Accordion toggle logic
   const handleAccordionToggle = (accordionId, type) => {
    setOpenAccordions((prev) => {
      const isOpen = !prev[accordionId];
      const updated = { ...prev, [accordionId]: isOpen };
      sessionStorage.setItem("havenKJAccordionState", JSON.stringify(updated));

      // only preload this section’s media when it’s opened
      if (isOpen && mediaSources[accordionId]) {
        const entries = Object.values(mediaSources[accordionId]);
        // 1️⃣ “Auto”-buffer the first (default) video immediately
        const firstVideoSrc = getGuideMediaPreloadSrc(entries[0]);
        if (firstVideoSrc) {
          const v0 = document.createElement("video");
          v0.src = firstVideoSrc;
          v0.preload = "auto";
          v0.load();
        }
        // 2️⃣ schedule metadata-only preloads for the rest during idle
        entries.slice(1).forEach((entry) => {
          const src = getGuideMediaPreloadSrc(entry);
          if (!src) {
            return;
          }
          const doMeta = () => {
            const v = document.createElement("video");
            v.src = src;
            v.preload = "metadata";
            v.load();
          };
          if ("requestIdleCallback" in window) {
            requestIdleCallback(doMeta, { timeout: 2000 });
          } else {
            setTimeout(doMeta, 2000);
          }
        });
      }
  

      if (isOpen) {
        if (type === "image") {
          setSelectedImage("image1");
        }

        if (type === "media" && mediaSources[accordionId]) {
          const firstKey = Object.keys(mediaSources[accordionId])[0];
          if (firstKey) {
            setSelectedMediaBySection((prev) => ({
              ...prev,
              [accordionId]: firstKey
            }));
          }
        }        
      }

      return updated;
    });
  };

  const renderMediaButtons = (sectionId) => {
    const sectionMedia = mediaSources[sectionId];
    if (!sectionMedia) return null;
  
    return (
      <>
        <button
        onClick={() => {
          console.log("Movement Guide button clicked ✅");
          setIsMovementGuideOpen(true);
        }}
        className="movement-guide-question-button"
      >
        ?
      </button>
        {Object.entries(sectionMedia).map(([key, { label }]) => (
          <button
            key={key}
            onClick={() =>
              setSelectedMediaBySection((prev) => ({
                ...prev,
                [sectionId]: key,
              }))
            }
            className={selectedMediaBySection[sectionId] === key ? "active" : ""}
          >
            {label}
          </button>
        ))}
      </>
    );
  };

  const renderSelectedMedia = (sectionId) => {
    const selectedKey = selectedMediaBySection[sectionId];
    const sectionMedia = mediaSources[sectionId];
  
    if (!selectedKey || !sectionMedia || !sectionMedia[selectedKey]) return null;
  
    const entry = sectionMedia[selectedKey];
    const { type, src, props = {} } = entry;

    if (isPlannedGuideMedia(entry)) {
      return <GuideMediaPlaceholder key={selectedKey} entry={entry} withFrame={false} />;
    }
  
    if (type === "image") {
      return <GuideImage key={selectedKey} src={src} alt={selectedKey} {...props} />;
    } else if (type === "video") {
      return (
        <LazyVideo
          key={selectedKey}
          src={src}
          preload="auto"
          forceLoad={true}            // ← add this
          {...props}
        />
      );
    }
  
    return null;
  };
  
  
  

  return (
    <div className={`page__container ${isBlurred ? "blurred-content" : ""}`}>
    <MovementGuideModal isOpen={isMovementGuideOpen} onClose={() => setIsMovementGuideOpen(false)} />
    <Highlight />
    <main className={`Main__content__container ${isBlurred ? "blurred-content" : ""}`}>
      <h1 className="M-A-Title">Haven KJ</h1> {/* Page Title */}

      <ul className="accordian"> 
        <li>
          <input
            type="checkbox"
            name="accordion-defense"
            id="Indiv-Haven-KJ-Defense-Main"
            checked={!!openAccordions["Defense-Main"]}
            onChange={() => handleAccordionToggle("Defense-Main")}
          />
          <label htmlFor="Indiv-Haven-KJ-Defense-Main">Defense</label>
          <div className="accordian__content">
            <ul>
              {/* <!-- Standard Setups --> */}
              <li>
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Haven-KJ-Standard-Setups"
                  checked={!!openAccordions["Standard-Setups"]}
                  onChange={() => handleAccordionToggle("Standard-Setups")}
                />
                <label htmlFor="Indiv-Haven-KJ-Standard-Setups">
                  Standard Setups
                  <Favorites
                    headingId="Indiv-Haven-KJ-Standard-Setups"
                    headingContent="Standard Setups"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>
                    {[
                      { id: "C-Site-and-Garage-Setup", label: "Default Setup" },
                      { id: "Default-Setup-Variation-1-(Passive Garage)", label: "Default Setup Variation 1 (Passive Garage)" },
                      { id: "A-Site-Anchor-Setup", label: "A-Site Anchor Setup" },
                      { id: "C-Site-Anchor-Setup", label: "C-Site Anchor Setup" }
                    ].map(({ id, label }) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="StandardSetups-sub"
                          id={`Indiv-Haven-KJ-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Haven-KJ-${id}`}
                            headingContent={label}
                            pageLocation="/Haven-KJ"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Ind-Haven-KJ-DEF-${label.replace(/\s+/g, "-")}`}>
                          <div className="image-selector">
                            {renderMediaButtons(id)}
                          </div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Setup strategy for {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* <!-- Retake Setups --> */}
              <li>
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Haven-KJ-Retake-Setups"
                  checked={!!openAccordions["Retake-Setups"]}
                  onChange={() => handleAccordionToggle("Retake-Setups")}
                />
                <label htmlFor="Indiv-Haven-KJ-Retake-Setups">
                  Retake Setups
                  <Favorites
                    headingId="Indiv-Haven-KJ-Retake-Setups"
                    headingContent="Retake Setups"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>
                    {["ARetake", "BRetake", "CRetake"].map((id) => {
                      const label = id.replace(/([A-Z])/, "$1-"); // e.g., "ARetake" => "A-Retake"
                      return (
                        <li key={id}>
                          <input
                            type="checkbox"
                            name="RetakeSetups-sub"
                            id={`Indiv-Haven-KJ-${id}`}
                            checked={!!openAccordions[id]}
                            onChange={() => handleAccordionToggle(id, "media")}
                          />
                          <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                            {label}
                            <Favorites
                              headingId={`Indiv-Haven-KJ-${id}`}
                              headingContent={label}
                              pageLocation="/Haven-KJ"
                              teamId={userTeamId}
                            />
                          </label>
                          <div className="accordian__content" data-container-id={`Ind-Haven-KJ-DEF-${label}`}>
                            <div className="image-selector">
                              {renderMediaButtons(id)}
                            </div>
                            <div className="retake-content__wrapper">
                              <div className="image__container">
                                <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                  {renderSelectedMedia(id)}
                                </div>
                              </div>
                              <div className="retake-text__container">
                                <p>Retake setup for {label}.</p>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>

              <li> 
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Haven-KJ-Defensive-Set-Plays"
                  checked={!!openAccordions["Defensive-Set-Plays"]}
                  onChange={() => handleAccordionToggle("Defensive-Set-Plays")}
                />
                <label htmlFor="Indiv-Haven-KJ-Defensive-Set-Plays">
                  Defensive Set-Plays
                  <Favorites
                    headingId="Indiv-Haven-KJ-Defensive-Set-Plays"
                    headingContent="Defensive Set-Plays"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content">
                  <ul>

                    {/* <!-- Eco Strats --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Haven-KJ-Eco-Strats"
                        checked={!!openAccordions["Eco-Strats"]}
                        onChange={() => handleAccordionToggle("Eco-Strats")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-Eco-Strats">
                        Eco Strats
                        <Favorites
                          headingId="Indiv-Haven-KJ-Eco-Strats"
                          headingContent="Eco Strats"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        <ul>
                          {[
                            "A-short Shorty trap",
                            "Walk down Mid",
                            "Garage short range",
                            "Walk down C-long"
                          ].map((title) => {
                            const id = title.replace(/\s+/g, "-");
                            return (
                              <li key={id}>
                                <input
                                  type="checkbox"
                                  name="EcoStrats-sub"
                                  id={`Indiv-Haven-KJ-${id}`}
                                  checked={!!openAccordions[id]}
                                  onChange={() => handleAccordionToggle(id, "media")}
                                />
                                <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                                  {title}
                                  <Favorites
                                    headingId={`Indiv-Haven-KJ-${id}`}
                                    headingContent={title}
                                    pageLocation="/Haven-KJ"
                                    teamId={userTeamId}
                                  />
                                </label>
                                <div className="accordian__content" data-container-id={`Ind-Haven-KJ-DEF-${id}`}>
                                  <div className="image-selector">
                                    {renderMediaButtons(id)}
                                  </div>
                                  <div className="retake-content__wrapper">
                                    <div className="image__container">
                                      <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                        {renderSelectedMedia(id)}
                                      </div>
                                    </div>
                                    <div className="retake-text__container">
                                      <p>Eco tactic: {title}.</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>

                    {/* <!-- Trap Plays --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Haven-KJ-Trap-Plays"
                        checked={!!openAccordions["Trap-Plays"]}
                        onChange={() => handleAccordionToggle("Trap-Plays")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-Trap-Plays">
                        Trap Plays
                        <Favorites
                          headingId="Indiv-Haven-KJ-Trap-Plays"
                          headingContent="Trap Plays"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        <ul>
                          {["A-Short Trap Play", "A-Long Trap Play", "Garage Trap Play"].map((title) => {
                            const id = title.replace(/\s+/g, "-");
                            return (
                              <li key={id}>
                                <input
                                  type="checkbox"
                                  name="TrapPlays-sub"
                                  id={`Indiv-Haven-KJ-${id}`}
                                  checked={!!openAccordions[id]}
                                  onChange={() => handleAccordionToggle(id, "media")}
                                />
                                <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                                  {title}
                                  <Favorites
                                    headingId={`Indiv-Haven-KJ-${id}`}
                                    headingContent={title}
                                    pageLocation="/Haven-KJ"
                                    teamId={userTeamId}
                                  />
                                </label>
                                <div className="accordian__content" data-container-id={`Ind-Haven-KJ-DEF-${id}`}>
                                  <div className="image-selector">
                                    {renderMediaButtons(id)}
                                  </div>
                                  <div className="retake-content__wrapper">
                                    <div className="image__container">
                                      <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                        {renderSelectedMedia(id)}
                                      </div>
                                    </div>
                                    <div className="retake-text__container">
                                      <p>Trap setup: {title}.</p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </li>

                    {/* <!-- Setups around Ultimate --> */}
                    <li>
                      <input
                        type="checkbox"
                        name="DefensiveSetPlays-sub"
                        id="Indiv-Haven-KJ-Plans-Ultimates"
                        checked={!!openAccordions["Plans-Ultimates"]}
                        onChange={() => handleAccordionToggle("Plans-Ultimates")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-Plans-Ultimates">
                        Setups around Ultimate
                        <Favorites
                          headingId="Indiv-Haven-KJ-Plans-Ultimates"
                          headingContent="Setups around Ultimate"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content">
                        {/* ← NEW descriptive block */}
                        <div className="retake-content__wrapper">
                          <div className="image__container">
                            <div className="Image-Border image-hover-effect">
                              <GuideImage
                                src="/assets/Ind-Haven/KJ/Ind-Haven-KJ-DEF-Garage&B-setup.png"
                                alt="Garage & B-site setup"
                              />
                            </div>
                          </div>
                          <div className="retake-text__container">
                            <h3 className="h-title-lg">Why Play for Retake with KJ Ultimate?</h3>

                            <p className="text-base">
                              Killjoy's ultimate is powerful for retakes because it forces attackers into a tough choice:
                            </p>

                            <ul className="text-base">
                              <li>
                                <strong>Abandon the site</strong> – Attackers must leave and then hurriedly attempt to reclaim it,
                                risking a failed defuse denial.
                              </li>
                              <li>
                                <strong>Push into defender territory</strong> – They have to aggressively fight through tight choke
                                points to destroy the ultimate, exposing themselves to easy eliminations.
                              </li>
                            </ul>

                            <p className="h-label">Typical Ultimate Positions:</p>
                            <ul className="text-base">
                              <li><strong>A-site retake:</strong> placed in A-Link.</li>
                              <li><strong>B and C-site retakes:</strong> placed in Garage window.</li>
                            </ul>

                            <p className="text-base">
                              Due to this, KJ players commonly prioritize controlling Garage and watching for lurks into B.
                              Maintaining control here allows flexibility for retakes across all three sites. If forced out,
                              KJs should prioritize re-clearing Garage and front B-space.
                            </p>

                            <p className="h-label">Standard Garage-Heavy Setup (for planned retake):</p>
                            <ul className="text-base">
                              <li>
                                <strong>Turret placement:</strong> Positioned to simultaneously hold Garage control and monitor C-site lurks.
                              </li>
                              <li>
                                <strong>First Nanoswarm:</strong> Placed near Garage door and activated by turret detection or enemy cues
                                (e.g., Sova drone) to delay/prevent entry.
                              </li>
                              <li>
                                <strong>Second Nanoswarm:</strong> Reserved to combo with the KJ ultimate during the retake, clearing spaces
                                outside the ult range and strengthening the retake.
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* end new block */}
                        <ul>
                          {/* How to Play A-Retake with Ult */}
                          <li>
                            <input
                              type="checkbox"
                              name="UltSetups-sub"
                              id="Indiv-Haven-KJ-How-to-Play-A-Retake-with-Ult"
                              checked={!!openAccordions["How-to-Play-A-Retake-with-Ult"]}
                              onChange={() => handleAccordionToggle("How-to-Play-A-Retake-with-Ult", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-How-to-Play-A-Retake-with-Ult">
                              How to Play A-Retake with Ult
                              <Favorites
                                headingId="Indiv-Haven-KJ-How-to-Play-A-Retake-with-Ult"
                                headingContent="How to Play A-Retake with Ult"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div
                              className="accordian__content"
                              data-container-id="Ind-Haven-KJ-DEF-How-to-Play-A-Retake-with-Ult"
                            >
                              <div className="image-selector">
                                {renderMediaButtons("How-to-Play-A-Retake-with-Ult")}
                              </div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="How-to-Play-A-Retake-with-Ult">
                                    {renderSelectedMedia("How-to-Play-A-Retake-with-Ult")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <h3 className="h-title-lg">A-Retake with KJ Ultimate</h3>

                                  <p className="text-base">
                                    The A-Retake with KJ&#39;s Ultimate is powerful because it forces attackers to either fall back off-site
                                    or push into <strong>A-Link</strong> to break the Ultimate. Combining the Ultimate with a
                                    <strong> Nanoswarm lineup at A-Long</strong> makes the retake even stronger, as it forces attackers
                                    to retreat further back into deep A-Long or A-Lobby, making it easier for you to retake the site.
                                  </p>

                                  <p className="h-label">Retake Sequence:</p>
                                  <ol className="num-list">
                                    <li>Combine your Ultimate with your Nanoswarm lineup (thrown at <strong>7 seconds</strong>).</li>
                                    <li>Have your team begin the retake as the Ultimate counter reaches <strong>4 seconds</strong>.</li>
                                  </ol>

                                  <p className="h-label">Threats to Watch Out For:</p>
                                  <ul className="text-base">
                                    <li>
                                      <strong>B-Lurk:</strong> If the B-flank watch is broken, re-clear front B with a teammate while rotating toward A.
                                    </li>
                                    <li>
                                      <strong>CT Push:</strong> Before using utilities in A-Link (Ultimate and Nanoswarm), call it out and ensure someone
                                      is holding for the CT push.
                                    </li>
                                  </ul>
                                </div>

                              </div>
                            </div>
                          </li>

                          {/* How to Play B-Retake with Ult */}
                          <li>
                            <input
                              type="checkbox"
                              name="UltSetups-sub"
                              id="Indiv-Haven-KJ-How-to-Play-B-Retake-with-Ult"
                              checked={!!openAccordions["How-to-Play-B-Retake-with-Ult"]}
                              onChange={() => handleAccordionToggle("How-to-Play-B-Retake-with-Ult", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-How-to-Play-B-Retake-with-Ult">
                              How to Play B-Retake with Ult
                              <Favorites
                                headingId="Indiv-Haven-KJ-How-to-Play-B-Retake-with-Ult"
                                headingContent="How to Play B-Retake with Ult"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div
                              className="accordian__content"
                              data-container-id="Ind-Haven-KJ-DEF-How-to-Play-B-Retake-with-Ult"
                            >
                              <div className="image-selector">
                                {renderMediaButtons("How-to-Play-B-Retake-with-Ult")}
                              </div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="How-to-Play-B-Retake-with-Ult">
                                    {renderSelectedMedia("How-to-Play-B-Retake-with-Ult")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <h3 className="h-title-lg">B-Retake with KJ Ultimate</h3>

                                  <p className="text-base">
                                    The B-Retake with KJ&#39;s Ultimate can be tricky because attackers may attempt to break it from multiple lanes.
                                    However, if you <strong>double up with a teammate to control Garage</strong> space, the Ultimate becomes very powerful.
                                    It forces attackers to either fight through <strong>A-Link</strong> or <strong>C-Link</strong> or retreat into the
                                    <strong> green zone (deep grass) and window</strong>.
                                  </p>

                                  <p className="h-label">Retake Sequence:</p>
                                  <ol className="num-list">
                                    <li><strong>Control Garage:</strong> Double up with a teammate to ensure Garage is secure and not contested.</li>
                                    <li>
                                      <strong>Set up:</strong> Ideally keep Garage turret for front Garage / potential C-Lurk.
                                      Have a teammate hold for the C-Link push.
                                    </li>
                                    <li><strong>Ultimate Placement:</strong> Pop your Nanoswarm in front of Garage while placing the Ultimate.</li>
                                    <li>
                                      <strong>Retake Timing:</strong> Begin the retake when the Ultimate timer hits <strong>4 seconds</strong>.
                                      <ol>
                                        <li>
                                          If Omen has two smokes, use them on <strong>Spike</strong> and <strong>Window</strong>.
                                        </li>
                                        <li>
                                          Use team utility to clear the <strong>green zone</strong> (e.g., Aftershock or Salvos) to kill attackers trapped there.
                                        </li>
                                      </ol>
                                      <em className="text-base">
                                        Note: With the green zone cleared and window smoked, attackers will have to either jump out of the window smoke
                                        or rush back from deep grass to prevent spike defusal.
                                      </em>
                                    </li>
                                    <li>
                                      <strong>KJ&#39;s Role:</strong> Play slowly out of Garage during the retake and backstab attackers trying to scramble
                                      back to B to deny spike defusal.
                                    </li>
                                  </ol>
                                </div>

                              </div>
                            </div>
                          </li>

                          {/* How to Play C-Retake with Ult */}
                          <li>
                            <input
                              type="checkbox"
                              name="UltSetups-sub"
                              id="Indiv-Haven-KJ-How-to-Play-C-Retake-with-Ult"
                              checked={!!openAccordions["How-to-Play-C-Retake-with-Ult"]}
                              onChange={() => handleAccordionToggle("How-to-Play-C-Retake-with-Ult", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-How-to-Play-C-Retake-with-Ult">
                              How to Play C-Retake with Ult
                              <Favorites
                                headingId="Indiv-Haven-KJ-How-to-Play-C-Retake-with-Ult"
                                headingContent="How to Play C-Retake with Ult"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div
                              className="accordian__content"
                              data-container-id="Ind-Haven-KJ-DEF-How-to-Play-C-Retake-with-Ult"
                            >
                              <div className="image-selector">
                                {renderMediaButtons("How-to-Play-C-Retake-with-Ult")}
                              </div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="How-to-Play-C-Retake-with-Ult">
                                    {renderSelectedMedia("How-to-Play-C-Retake-with-Ult")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <h3 className="h-title-lg">C-Retake with KJ Ultimate</h3>

                                  <p className="text-base">
                                    The C-Retake with KJ&#39;s Ultimate is very strong, as it forces attackers to either fight into
                                    <strong> Garage</strong> or <strong>C-Link</strong> to break the Ultimate, or fall far back to
                                    <strong> C-Long</strong> or <strong>Back Plat</strong>. When combined with a Nanoswarm lineup,
                                    <strong> Back Plat becomes unplayable</strong>.
                                  </p>

                                  <p className="h-label">Preparation:</p>
                                  <p className="text-base">
                                    Garage control is essential. Try holding it from the start, and if forced back, call for a teammate to help you
                                    re-clear it before going for the retake and placing the Ultimate.
                                  </p>

                                  <p className="h-label">Retake Sequence:</p>
                                  <ol className="num-list">
                                    <li><strong>Secure Garage:</strong> Go Garage with a teammate and have another teammate watch Spawn push.</li>
                                    <li><strong>Place Ultimate:</strong> Drop Ultimate and use a <strong>Front Garage Nanoswarm</strong> to block a push.</li>
                                    <li><strong>Nanoswarm Lineup:</strong> Throw to clear <strong>Back Plat</strong> when the Ult timer hits <strong>7s</strong>.</li>
                                    <li><strong>Timing the Retake:</strong> Begin the site retake when the Ult timer hits <strong>3s</strong>.</li>
                                    <li><strong>Watch for Lurks:</strong> If a B-lurk or late Garage lurk appears, call that you’ll handle it.</li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>

                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              {/* Specific Agent Counters (Defense) */}
              <li>
                <input
                  type="checkbox"
                  name="Defense-sub"
                  id="Indiv-Haven-KJ-Defense-Specific-Agent-Counters"
                  checked={!!openAccordions["Defense-Specific-Agent-Counters"]}
                  onChange={() => handleAccordionToggle("Defense-Specific-Agent-Counters")}
                />
                <label htmlFor="Indiv-Haven-KJ-Defense-Specific-Agent-Counters">
                  Specific Agent Counters
                  <Favorites
                    headingId="Indiv-Haven-KJ-Defense-Specific-Agent-Counters"
                    headingContent="Specific Agent Counters"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Defense-Specific-Agent-Counters">
                  <ul>
                    <li><p>More counters coming soon…</p></li>
                  </ul>
                </div>
              </li>


            </ul>
          </div>
        </li>


        {/* Attack Main Accordion */}
        <li>
          <input
            type="checkbox"
            name="accordion-attack"
            id="Indiv-Haven-KJ-Attack-Main"
            checked={!!openAccordions["Attack-Main"]}
            onChange={() => handleAccordionToggle("Attack-Main")}
          />
          <label htmlFor="Indiv-Haven-KJ-Attack-Main">Attack</label>
          <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Attack-Main">
            <ul>
              {/* 1) How to Default As KJ */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Haven-KJ-How-to-Default-As-KJ"
                  checked={!!openAccordions["How-to-Default-As-KJ"]}
                  onChange={() => handleAccordionToggle("How-to-Default-As-KJ")}
                />
                <label htmlFor="Indiv-Haven-KJ-How-to-Default-As-KJ">
                  How to Default As KJ
                  <Favorites
                    headingId="Indiv-Haven-KJ-How-to-Default-As-KJ"
                    headingContent="How to Default As KJ"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-How-to-Default-As-KJ">
                  <ul>
                    {[
                      ["A-Hit-with-4-or-A-Heavy-Default", "A-Hit with 4 / A-Heavy Default"],
                      ["Team-Heavy-B-or-Garage-Default", "Team Heavy B / Garage Default"],
                      ["C-or-Garage-Heavy-Default", "C-Site / Garage Heavy Default"],
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="DefaultKJ-sub"
                          id={`Indiv-Haven-KJ-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Haven-KJ-${id}`}
                            headingContent={label}
                            pageLocation="/Haven-KJ"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Haven-KJ-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Default setup: {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* 2) Site-Hit Positioning & Pathing */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Haven-KJ-Site-Hit-Positioning-and-Pathing"
                  checked={!!openAccordions["Site-Hit-Positioning-and-Pathing"]}
                  onChange={() => handleAccordionToggle("Site-Hit-Positioning-and-Pathing")}
                />
                <label htmlFor="Indiv-Haven-KJ-Site-Hit-Positioning-and-Pathing">
                  Site-Hit Positioning & Pathing
                  <Favorites
                    headingId="Indiv-Haven-KJ-Site-Hit-Positioning-and-Pathing"
                    headingContent="Site-Hit Positioning & Pathing"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>

                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Site-Hit-Positioning-and-Pathing">
                  <ul>
                    {/* A-Hit (parent) */}
                    <li>
                      <input
                        type="checkbox"
                        name="SiteHit-sub"
                        id="Indiv-Haven-KJ-A-Hit"
                        checked={!!openAccordions["A-Hit"]}
                        onChange={() => handleAccordionToggle("A-Hit")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-A-Hit">
                        A-Hit
                        <Favorites
                          headingId="Indiv-Haven-KJ-A-Hit"
                          headingContent="A-Hit"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>

                      <div className="accordian__content" data-container-id="Indiv-Haven-KJ-A-Hit">
                        <ul>
                          {/* Committed A Hit From Long */}
                          <li>
                            <input
                              type="checkbox"
                              name="SiteHit-sub"
                              id="Indiv-Haven-KJ-Committed-A-Hit-From-Long"
                              checked={!!openAccordions["Committed-A-Hit-From-Long"]}
                              onChange={() => handleAccordionToggle("Committed-A-Hit-From-Long", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-Committed-A-Hit-From-Long">
                              Committed A Hit From Long
                              <Favorites
                                headingId="Indiv-Haven-KJ-Committed-A-Hit-From-Long"
                                headingContent="Committed A Hit From Long"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Committed-A-Hit-From-Long">
                              <div className="image-selector">{renderMediaButtons("Committed-A-Hit-From-Long")}</div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="Committed-A-Hit-From-Long">
                                    {renderSelectedMedia("Committed-A-Hit-From-Long")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <p>Committed A Hit from Long.</p>
                                </div>
                              </div>
                            </div>
                          </li>

                          {/* Committed A-Hit From Short */}
                          <li>
                            <input
                              type="checkbox"
                              name="SiteHit-sub"
                              id="Indiv-Haven-KJ-Committed-A-Hit-From-Short"
                              checked={!!openAccordions["Committed-A-Hit-From-Short"]}
                              onChange={() => handleAccordionToggle("Committed-A-Hit-From-Short", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-Committed-A-Hit-From-Short">
                              Committed A-Hit From Short
                              <Favorites
                                headingId="Indiv-Haven-KJ-Committed-A-Hit-From-Short"
                                headingContent="Committed A-Hit From Short"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Committed-A-Hit-From-Short">
                              <div className="image-selector">{renderMediaButtons("Committed-A-Hit-From-Short")}</div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="Committed-A-Hit-From-Short">
                                    {renderSelectedMedia("Committed-A-Hit-From-Short")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <p>Committed A-Hit from Short.</p>
                                </div>
                              </div>
                            </div>
                          </li>

                          {/* A-Hit Support With Mid-Rewrap */}
                          <li>
                            <input
                              type="checkbox"
                              name="SiteHit-sub"
                              id="Indiv-Haven-KJ-A-Hit-Support-With-Mid-Rewrap"
                              checked={!!openAccordions["A-Hit-Support-With-Mid-Rewrap"]}
                              onChange={() => handleAccordionToggle("A-Hit-Support-With-Mid-Rewrap", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-A-Hit-Support-With-Mid-Rewrap">
                              A-Hit Support With Mid-Rewrap
                              <Favorites
                                headingId="Indiv-Haven-KJ-A-Hit-Support-With-Mid-Rewrap"
                                headingContent="A-Hit Support With Mid-Rewrap"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div className="accordian__content" data-container-id="Indiv-Haven-KJ-A-Hit-Support-With-Mid-Rewrap">
                              <div className="image-selector">{renderMediaButtons("A-Hit-Support-With-Mid-Rewrap")}</div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="A-Hit-Support-With-Mid-Rewrap">
                                    {renderSelectedMedia("A-Hit-Support-With-Mid-Rewrap")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <p>A-Hit support pathing and rewrap timings.</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* B-Hit (flat) */}
                    <li>
                      <input
                        type="checkbox"
                        name="SiteHit-sub"
                        id="Indiv-Haven-KJ-B-Hit"
                        checked={!!openAccordions["B-Hit"]}
                        onChange={() => handleAccordionToggle("B-Hit", "media")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-B-Hit">
                        B-Hit
                        <Favorites
                          headingId="Indiv-Haven-KJ-B-Hit"
                          headingContent="B-Hit"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content" data-container-id="Indiv-Haven-KJ-B-Hit">
                        <div className="image-selector">{renderMediaButtons("B-Hit")}</div>
                        <div className="retake-content__wrapper">
                          <div className="image__container">
                            <div className="Image-Border image-hover-effect" data-zoom-id="B-Hit">
                              {renderSelectedMedia("B-Hit")}
                            </div>
                          </div>
                          <div className="retake-text__container">
                            <p>B-Hit overview.</p>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* C-Hit (parent) */}
                    <li>
                      <input
                        type="checkbox"
                        name="SiteHit-sub"
                        id="Indiv-Haven-KJ-C-Hit"
                        checked={!!openAccordions["C-Hit"]}
                        onChange={() => handleAccordionToggle("C-Hit")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-C-Hit">
                        C-Hit
                        <Favorites
                          headingId="Indiv-Haven-KJ-C-Hit"
                          headingContent="C-Hit"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>

                      <div className="accordian__content" data-container-id="Indiv-Haven-KJ-C-Hit">
                        <ul>
                          {/* C-Long-Hit */}
                          <li>
                            <input
                              type="checkbox"
                              name="SiteHit-sub"
                              id="Indiv-Haven-KJ-C-Long-Hit"
                              checked={!!openAccordions["C-Long-Hit"]}
                              onChange={() => handleAccordionToggle("C-Long-Hit", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-C-Long-Hit">
                              C-Long-Hit
                              <Favorites
                                headingId="Indiv-Haven-KJ-C-Long-Hit"
                                headingContent="C-Long-Hit"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div className="accordian__content" data-container-id="Indiv-Haven-KJ-C-Long-Hit">
                              <div className="image-selector">{renderMediaButtons("C-Long-Hit")}</div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="C-Long-Hit">
                                    {renderSelectedMedia("C-Long-Hit")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <p>C-Long hit utility.</p>
                                </div>
                              </div>
                            </div>
                          </li>

                          {/* C-Split */}
                          <li>
                            <input
                              type="checkbox"
                              name="SiteHit-sub"
                              id="Indiv-Haven-KJ-C-Split"
                              checked={!!openAccordions["C-Split"]}
                              onChange={() => handleAccordionToggle("C-Split", "media")}
                            />
                            <label htmlFor="Indiv-Haven-KJ-C-Split">
                              C-Split
                              <Favorites
                                headingId="Indiv-Haven-KJ-C-Split"
                                headingContent="C-Split"
                                pageLocation="/Haven-KJ"
                                teamId={userTeamId}
                              />
                            </label>
                            <div className="accordian__content" data-container-id="Indiv-Haven-KJ-C-Split">
                              <div className="image-selector">{renderMediaButtons("C-Split")}</div>
                              <div className="retake-content__wrapper">
                                <div className="image__container">
                                  <div className="Image-Border image-hover-effect" data-zoom-id="C-Split">
                                    {renderSelectedMedia("C-Split")}
                                  </div>
                                </div>
                                <div className="retake-text__container">
                                  <p>C-Split overview and CT Molly from Grass.</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              {/* 3) ✅ NEW top-level: Plans Around Ultimate */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Haven-KJ-Plans-Around-Ultimate"
                  checked={!!openAccordions["Plans-Around-Ultimate"]}
                  onChange={() => handleAccordionToggle("Plans-Around-Ultimate")}
                />
                <label htmlFor="Indiv-Haven-KJ-Plans-Around-Ultimate">
                  Plans Around Ultimate
                  <Favorites
                    headingId="Indiv-Haven-KJ-Plans-Around-Ultimate"
                    headingContent="Plans Around Ultimate"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>

                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Plans-Around-Ultimate">
                  <ul>
                    {[
                      ["A-Site-Ult", "A-Site Ult"],
                      ["B-Site-Ult", "B-Site Ult"],
                      ["C-Site-Ult", "C-Site Ult"],
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="UltPlans-sub"
                          id={`Indiv-Haven-KJ-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Haven-KJ-${id}`}
                            headingContent={label}
                            pageLocation="/Haven-KJ"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Haven-KJ-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Ult plan for {label.replace(" Ult", "")}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* 4) Post-Plants */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Haven-KJ-Post-Plants"
                  checked={!!openAccordions["Post-Plants"]}
                  onChange={() => handleAccordionToggle("Post-Plants")}
                />
                <label htmlFor="Indiv-Haven-KJ-Post-Plants">
                  Post-Plants
                  <Favorites
                    headingId="Indiv-Haven-KJ-Post-Plants"
                    headingContent="Post-Plants"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>
                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Post-Plants">
                  <ul>
                    {[
                      ["A-PP-Nano", "A-PP Nano"],
                      ["B-PP-Nano", "B-PP Nano"],
                      ["C-PP-Nano", "C-PP Nano"],
                    ].map(([id, label]) => (
                      <li key={id}>
                        <input
                          type="checkbox"
                          name="PostPlant-sub"
                          id={`Indiv-Haven-KJ-${id}`}
                          checked={!!openAccordions[id]}
                          onChange={() => handleAccordionToggle(id, "media")}
                        />
                        <label htmlFor={`Indiv-Haven-KJ-${id}`}>
                          {label}
                          <Favorites
                            headingId={`Indiv-Haven-KJ-${id}`}
                            headingContent={label}
                            pageLocation="/Haven-KJ"
                            teamId={userTeamId}
                          />
                        </label>
                        <div className="accordian__content" data-container-id={`Indiv-Haven-KJ-${id}`}>
                          <div className="image-selector">{renderMediaButtons(id)}</div>
                          <div className="retake-content__wrapper">
                            <div className="image__container">
                              <div className="Image-Border image-hover-effect" data-zoom-id={id}>
                                {renderSelectedMedia(id)}
                              </div>
                            </div>
                            <div className="retake-text__container">
                              <p>Post-plant setup: {label}.</p>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>

              {/* 5) Specific Agent Counters (Attack) */}
              <li>
                <input
                  type="checkbox"
                  name="Attack-sub"
                  id="Indiv-Haven-KJ-Attack-Specific-Agent-Counters"
                  checked={!!openAccordions["Attack-Specific-Agent-Counters"]}
                  onChange={() => handleAccordionToggle("Attack-Specific-Agent-Counters")}
                />
                <label htmlFor="Indiv-Haven-KJ-Attack-Specific-Agent-Counters">
                  Specific Agent Counters
                  <Favorites
                    headingId="Indiv-Haven-KJ-Attack-Specific-Agent-Counters"
                    headingContent="Specific Agent Counters"
                    pageLocation="/Haven-KJ"
                    teamId={userTeamId}
                  />
                </label>

                <div className="accordian__content" data-container-id="Indiv-Haven-KJ-Attack-Specific-Agent-Counters">
                  <ul>
                    <li>
                      <input
                        type="checkbox"
                        name="AttackCounters-sub"
                        id="Indiv-Haven-KJ-KJ-A-Retake-Ult-Counter"
                        checked={!!openAccordions["KJ-A-Retake-Ult-Counter"]}
                        onChange={() => handleAccordionToggle("KJ-A-Retake-Ult-Counter", "media")}
                      />
                      <label htmlFor="Indiv-Haven-KJ-KJ-A-Retake-Ult-Counter">
                        KJ A-Retake Ult Counter
                        <Favorites
                          headingId="Indiv-Haven-KJ-KJ-A-Retake-Ult-Counter"
                          headingContent="KJ A-Retake Ult Counter"
                          pageLocation="/Haven-KJ"
                          teamId={userTeamId}
                        />
                      </label>
                      <div className="accordian__content" data-container-id="Indiv-Haven-KJ-KJ-A-Retake-Ult-Counter">
                        <div className="image-selector">{renderMediaButtons("KJ-A-Retake-Ult-Counter")}</div>
                        <div className="retake-content__wrapper">
                          <div className="image__container">
                            <div className="Image-Border image-hover-effect" data-zoom-id="KJ-A-Retake-Ult-Counter">
                              {renderSelectedMedia("KJ-A-Retake-Ult-Counter")}
                            </div>
                          </div>
                          <div className="retake-text__container">
                            <p>How to counter KJ A-Retake Ultimate with nanos.</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>

          </div>
        </li>





        
        {/* Common Agent Combos Accordion */}
          <li>
            <input
              type="checkbox"
              name="accordion"
              id="Indiv-Haven-KJ-Common-Agent-Combos"
              checked={!!openAccordions["Common-Agent-Combos"]}
              onChange={() => handleAccordionToggle("Common-Agent-Combos")}
            />
            <label htmlFor="Indiv-Haven-KJ-Common-Agent-Combos">
              Common Agent Combos
            </label>
            <div
              className="accordian__content"
              data-container-id="Indiv-Haven-KJ-Common-Agent-Combos"
            >
              <ul>
                <li>
                  <p>Content about common agent combos...</p>
                </li>
              </ul>
            </div>
          </li>



      </ul>
    </main>



      {/* Footer Section */}
      <section className="footer-section">
        <Footer />
      </section>
    </div>
  );
};

export default HavenKJ;
